import { render, staticRenderFns } from "./Dashboard_18.vue?vue&type=template&id=3742dedc&"
var script = {}
import style0 from "./Dashboard_18.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports